<!-- 角色列表 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">角色列表</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;width: 860px;">
		<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<!-- ID -->
				<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<!-- 用户登录名 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
					{{item.name}}
				</div>
				<!-- 用户名称 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
					{{item.slug}}
				</div>
				<!-- 操作 -->
				<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					编辑
				</div>
				<!-- 创建时间 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
					{{item.created_at}}
				</div>
				<!-- 更新时间 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
					{{item.updated_at}}
				</div>
			</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
		<a-pagination v-model="r_page" :pageSize="20" :total="table_total" @change="paginationChange" hideOnSinglePage />
		
	</div>
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="850px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 0;">
			
			<div class="form-cell-box">
				<div class="class-title">角色名称</div>
					
				<a-input v-model="x_name" placeholder="请输入" style="width: 260px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">角色标识</div>
					
				<a-input v-model="x_slug" placeholder="请输入" style="width: 260px;"  />
			</div>
			<div style="color: red;margin-left: 85px;margin-bottom: 20px;margin-top: -15px;">注：不能新增一个重复的角色标识！</div>
			
			
			<div class="form-cell-box" style="align-items: baseline;">
				<div class="class-title" style="flex-shrink: 0;">路由</div>
				
				<div style="width: 700px;">
					<div v-for="(item,index) in routeGroup" :key="index" style="margin-bottom: 25px;">
						<a-checkbox :indeterminate="item.indeterminate_all" :checked="item.checked_all" @change="onCheckAllChange($event,item,index)">
							{{item.label}}
						</a-checkbox>
						<div style="display: flex;align-items: center;flex-wrap: wrap;margin-left: 20px;margin-top: 10px;">
							<div v-for="(item_z,index_z) in item.value" :key="index_z" style="margin-bottom: 5px;margin-right: 10px;">
								<a-checkbox  :checked="item_z.checked_z" @change="onCheckChange($event,index,index_z)">
									{{item_z.name}}
								</a-checkbox>
							</div>
							
						</div>
					</div>
				</div>
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 20px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { roleList, routeListGroup, roleAdd, roleEdit, roleRouteInfo, roleSetRoute } from '@/request/api'

export default {
	name: 'roles_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"角色名称", width:160, type:"name", },
				{title:"用户标识", width:180, type:"slug", },
				{title:"操作", width:100, type:"cz", },
				{title:"创建时间", width:200, type:"created_at", },
				{title:"更新时间", width:200, type:"updated_at", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			search_button_loading: false,
			
			r_page: 1,
			table_total: 0,
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			x_id: "", // id
			x_name: "", // 角色名称
			x_slug: "", // 角色标识
			x_menu_ids: "", // 菜单id数组
			
			routeGroup: [], // 路由列表
		}
	},
	mounted(){
		let that = this
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		that.searchButton()
		
		// 获取路由分组列表
		routeListGroup().then(res=>{
			console.log("路由分组",res.data.data) 
			// 对数据进行处理
			let data = res.data.data.list
			let k_data = Object.keys(data)
			let v_data = []
			k_data.forEach(res=>{
				let obj = {
					label: res,
					checked_all: false,
					indeterminate_all: false,
				}
				let z_data = data[res]
				z_data.forEach(res_z=>{
					res_z.checked_z = false
				})
				obj.value = z_data
				v_data.push(obj)
			})
			console.log("v_data",v_data)
			that.routeGroup = v_data
		})
	},
	methods:{
		// 搜索
		searchButton(){
			let that = this
			
			that.search_button_loading = true
			
			roleList({page: that.r_page}).then(res=>{
				console.log("列表结果",res.data.data)
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					
					that.table_total = res.data.data.total
					
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增
		addButton(){
			let that = this
			that.drawer_title = "新增"
			that.visible = true
		},
		// 编辑
		editTable(index,item){
			let that = this
			console.log(item);
			that.drawer_title = "编辑"
			that.x_id = item.id
			this.x_name = item.name // 角色名称
			this.x_slug = item.slug // 角色标识
			roleRouteInfo({role_id: item.id}).then(res=>{
				console.log("编辑",res);
				let data = res.data.data.list
				let k_data = Object.keys(data)
				console.log("k_data",k_data);
				that.routeGroup.forEach(res=>{
					let ttt = true
					res.value.forEach(res_z=>{
						k_data.forEach(res_k=>{
							if(res_z.id == res_k){
								res_z.checked_z = true
							}
						})
						if(!res_z.checked_z){ // 有一个没选中说明就没有全选了
							ttt = false
						}
					})
					
					if(ttt){
						res.checked_all = true // 全选
					}
				})
				
				that.visible = true
			})
		},
		
		// 侧边栏的确认按钮
		addRequest(){
			let that = this
			if(!that.x_name){
				that.add_form_hint = "请填写角色名称"
			}
			else if(!that.x_slug){
				that.add_form_hint = "请填写角色标识"
			}
			// 路由不是必填项
			else {
				that.add_button_loading = true
				let i_data = [] // 把选中的路由id放入里面
				that.routeGroup.forEach(res=>{
					res.value.forEach(res_z=>{
						if(res_z.checked_z){
							i_data.push(res_z.id)
						}
					})
				})
				console.log("i_data",i_data)
				
				that.add_form_hint = ""
				
				function setR(id){
					roleSetRoute({
						role_id: id,
						route_ids: i_data
					}).then(res_r=>{
						console.log("角色分配权限",res_r)
						that.add_button_loading = false
						that.onCloseDrawer()
						that.$message.success('操作成功');
						that.searchButton()
					})
				}
				
				if(that.drawer_title == "新增"){
					// 新增
					roleAdd({
						name: that.x_name,
						slug: that.x_slug
						// menu_ids: i_data
					}).then(res=>{
						console.log("新增",res)
						
						if(res.data.code == 0){
							setR(res.data.data.id)
							
						}
						else {
							that.add_button_loading = false
							that.$message.error(res.data.msg || "请求失败");
						}
					})
					.catch(err=>{
						that.add_button_loading = false
						console.log(err)
						that.$message.error("请求失败，可能是网络出现问题");
					})
				}
				else if(that.drawer_title == "编辑"){
					roleEdit({
						id: that.x_id,
						name: that.x_name,
						slug: that.x_slug
					}).then(res=>{
						console.log("编辑",res)
						if(res.data.code == 0){
							setR(that.x_id)
							
						}
						else {
							that.add_button_loading = false
							that.$message.error(res.data.msg || "请求失败");
						}
					})
					.catch(err=>{
						that.add_button_loading = false
						console.log(err)
						that.$message.error("请求失败，可能是网络出现问题");
					})
				}
				
				
			}
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			
			this.x_name = "" // 角色名称
			this.x_slug = "" // 角色标识
			this.add_form_hint = ""
			
			this.routeGroup.forEach(res=>{
				res.checked_all = false
				res.value.forEach(res_z=>{
					res_z.checked_z = false
				})
			})
			
			this.visible = false
		},
		// 全选/取消全选
		onCheckAllChange(e,item,index){
			let that = this
			if(that.routeGroup[index].checked_all){
				that.routeGroup[index].value.forEach(res=>{
					res.checked_z = false
				})
				that.routeGroup[index].checked_all = false
				// that.routeGroup[index].indeterminate_all = false
			}
			else {
				that.routeGroup[index].value.forEach(res=>{
					res.checked_z = true
				})
				that.routeGroup[index].checked_all = true
				// that.routeGroup[index].indeterminate_all = true
			}
		},
		// 单选
		onCheckChange(e,index,index_z){
			let that = this
			console.log(that.routeGroup[index].value[index_z].id)
			that.routeGroup[index].value[index_z].checked_z = !that.routeGroup[index].value[index_z].checked_z
			
			let ttt = true // 用于判断是否全选
			that.routeGroup[index].value.forEach(res=>{
				if(!res.checked_z){
					ttt = false
				}
			})
			if(ttt){
				that.routeGroup[index].checked_all = true // 全选
			}
			else {
				that.routeGroup[index].checked_all = false // 取消全选
			}
		},
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
			
		},
	},
}
</script>

<style scoped>
.page-title {
	text-align: left;
	font-weight: 500;
	font-size: 24px;
}

.screen-box {
	display: flex;
	align-items: center;
	margin-right: 30px;
	/* margin-bottom: 25px; */
}
.screen-label {
	flex-shrink: 0;
	margin-right: 15px;
}


/* 表格部分的样式 */
.table-th {
	position:sticky;
	top: 65px;
	z-index:3;
	display: flex;
	align-items: center;
	background-color: #fbfbfb;
	border-bottom: 1px solid #e8e8e8;
}
.table-th-cell {
	display: flex;
	align-items: center;
	padding: 12px;
	cursor: default;
	color: #060606;
	flex-shrink: 0;
	user-select: none;
	border-bottom: none;
}

.table-td {
	
	display: flex;
	align-items: center;
	width: 100%;
	border-bottom: 1px solid #e8e8e8;
}
.table-td:hover {
	background-color: #eff9ff;
}
.table-td:hover .table-td-cell-sticky{
	background-color: #eff9ff;
}
.table-td-cell {
	padding: 12px;
	flex-shrink: 0;
	cursor: default;
	
	color: rgba(0, 0, 0, 0.65);
	min-height: 45px;
	font-size: 13px;
	/* overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis; */
}


.form-cell-box {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}
.class-title {
	font-size: 14px;
	margin-right: 25px;
	width: 60px;
	color: #333;
	text-align: right;
}
</style>